import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-links">
          <a 
            href="https://t.me/selfai_support" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Поддержка
          </a>
          <a 
            href="https://t.me/selfai_support" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Рекламодателям
          </a>
          <a 
            href="/public_offer.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Публичная оферта
          </a>
          <a 
            href="/privacy_policy.pdf" 
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Политика обработки персональных данных
          </a>
          <Link
            to="/blog"
            className="footer-link"
          >
            Блог
          </Link>
          <Link
            to="/courses"
            className="footer-link"
          >
            Обучение/курсы
          </Link>
          <Link
            to="/contacts"
            className="footer-link"
          >
            Контакты
          </Link>
        </div>
        
        <div className="footer-company">
          <p className="footer-company-name">ООО "САХА КОНТЕНТ"</p>
          <p className="footer-company-details">
            ИНН 1400007690, ОГРН 1221400004297
          </p>
          <p className="footer-company-details">
            Регистрационный номер 14-25-002616 в Реестре операторов РКН
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

